import { LocalGasStationOutlined } from "@material-ui/icons";
import { FuelProviderCreate } from "./FuelProviderCreate";
import { FuelProviderEdit } from "./FuelProviderEdit";
import { FuelProvidersList } from "./FuelProvidersList";

export default {
  icon: LocalGasStationOutlined,
  list: FuelProvidersList,
  create: FuelProviderCreate,
  edit: FuelProviderEdit,
};
